import "babel-polyfill";

import routerConfig from './app.route.js';

import appConfig from './app.config.js';

import runApp from './app.run.js';

import firebaseConfig from './app.firebase.config.js';

import './app.constants.js'; //Includes dynamically created constants object

import './services/services.module.js';

import './components/loginForm/loginForm.module.js';

import './ecourse/ecourse.module.js';

import './shared/directives/directives.module.js';

import './components/menu/menu.module.js';

import './components/share/share.module.js';

import {ExceptionHandler, ExceptionService} from './app.errors.js';

import AppController from './app.controller.js';

require('angulartics');

angular.module('app', [ 'ui.router',
                        'ct.ui.router.extras.core',
                        'ct.ui.router.extras.sticky',
                        'ct.ui.router.extras.previous',
                        'app.constants',
                        'app.services',
                        'app.loginForm',
                        'app.directives',
                        'app.ecourse',
                        'ngSanitize',
                        'ngMessages',
                        'matchmedia-ng',
                        'app.menu',
                        'app.share',
                        'ngAnimate',
                        'angulartics',
                        require('angulartics-google-analytics'),
                        'angulartics.facebook.pixel',
                        'firebase'])
  .decorator('$exceptionHandler', ExceptionHandler)
  .service('$exceptionService', ExceptionService)
  .factory('JwplayerFactory', function($window) {
      return $window.jwplayer;
  })
  //TODO - Find a better way than hard coding these here.
  .constant('breakpoints', {
    small: '(max-width: 767px)',
    medium: '(min-width: 768px) and (max-width: 1024px)',
    mediumStart: '(min-width: 768px)',
    largeStart: '(min-width: 1025px)',
    large: '(min-width: 1025px) and (max-width: 1439px)',
    xLarge: '(min-width: 1440px) and (max-width: 1919px)',
    xxLarge: '(min-width: 1920px)'
  })

  .controller('AppController', AppController)
  .run(runApp)
  .config(appConfig)
  .config(routerConfig)
  .config(firebaseConfig);



/** WEBPACK FOOTER **
 ** ./src/app/app.module.js
 **/